
export default function Testimonials() {
  const testimonials = [
    {
      name: "Jean Jacques ABALLEA",
      location: "Nantes",
      rating: 5,
      text: "Très satisfait de l'intervention sur mon tableau électrique : travail rapide, soigné et professionnel. L'électricien a été clair dans ses explications et a laissé le chantier impeccable. Je recommande vivement ses services !",
      avatar: "https://public.readdy.ai/ai/img_res/112a45a079b735a6ceaa65d714b22466.jpg",
      date: "il y a 8 mois",
      verified: true
    },
    {
      name: "Baptiste Colin",
      location: "Nantes",
      rating: 5,
      text: "Suite à plusieurs coupures de courants, nous avons fait appel à Paolo qui est venu en début de soirée pour nous dépanner. Par la suite et après un devis à un très bon prix, le tableau électrique a été changé et remis aux normes, et plus aucune coupures de courants par la suite. Nous avons également eu appel à Paolo pour venir installer une sonnette et régler la sonnette extérieure. Très réactif et d'une très grande gentillesse, Merci !",
      avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20young%20French%20man%20in%20his%2030s%20with%20brown%20hair%20and%20beard%2C%20wearing%20modern%20casual%20clothing%2C%20bright%20confident%20smile%2C%20natural%20daylight%2C%20contemporary%20headshot%20photography&width=80&height=80&seq=testimonial-baptiste-unique&orientation=squarish",
      date: "il y a 5 mois",
      verified: true
    },
    {
      name: "Hélène Delavaud",
      location: "Nantes",
      rating: 5,
      text: "Paolo est très efficace et avait la pièce de rechange du thermostat dans son camion! Également très sympathique et très disponible ! Je recommande vivement !",
      avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20French%20woman%20in%20her%2040s%20with%20blonde%20hair%2C%20wearing%20stylish%20blouse%2C%20warm%20genuine%20smile%2C%20soft%20natural%20lighting%2C%20professional%20female%20headshot%20photography&width=80&height=80&seq=testimonial-helene-unique&orientation=squarish",
      date: "il y a 3 mois",
      verified: true
    },
    {
      name: "Jean-Marie MATHE",
      location: "Nantes",
      rating: 5,
      text: "Travail réalisé selon devis, qualitatif, réalisé avec soins. Société très à l'écoute de son client et de bon conseil : très professionnel. Je recommande.",
      avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20mature%20French%20businessman%20in%20his%2050s%20with%20dark%20hair%20and%20glasses%2C%20wearing%20collared%20shirt%2C%20serious%20but%20satisfied%20expression%2C%20office%20lighting%2C%20executive%20headshot%20photography&width=80&height=80&seq=testimonial-jean-marie-unique&orientation=squarish",
      date: "il y a 6 mois",
      verified: true
    },
    {
      name: "Sylvie Mathe",
      location: "Nantes",
      rating: 5,
      text: "Intervention rapide et de qualité avec professionnalisme. A pris le temps de bien prendre en compte notre demande. Je recommande cette entreprise.",
      avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20professional%20French%20woman%20in%20her%2050s%20with%20short%20brown%20hair%2C%20wearing%20elegant%20jacket%2C%20confident%20pleasant%20smile%2C%20indoor%20natural%20lighting%2C%20mature%20female%20headshot%20photography&width=80&height=80&seq=testimonial-sylvie-mathe-unique&orientation=squarish",
      date: "il y a 4 mois",
      verified: true
    },
    {
      name: "Jacqueline Ollivier",
      location: "Nantes",
      rating: 5,
      text: "Dépannage électrique rapide et efficace le tout avec une gentillesse de l'intervenant à conseiller.",
      avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20elderly%20French%20lady%20in%20her%2070s%20with%20silver%20hair%2C%20wearing%20colorful%20cardigan%2C%20gentle%20motherly%20smile%2C%20warm%20home%20lighting%2C%20senior%20woman%20headshot%20photography&width=80&height=80&seq=testimonial-jacqueline-unique&orientation=squarish",
      date: "il y a 2 mois",
      verified: true
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-amber-400`}
      ></i>
    ));
  };

  return (
    <section className="py-20 bg-stone-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-nunito">
            Avis clients
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-nunito">
            La satisfaction de nos clients, notre plus belle récompense
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-bold text-gray-800 font-nunito text-sm">{testimonial.name}</h4>
                  <p className="text-gray-600 text-xs font-nunito">{testimonial.location}</p>
                  <div className="flex mt-1">
                    {renderStars(testimonial.rating)}
                  </div>
                  <p className="text-xs text-gray-500 font-nunito mt-1">{testimonial.date}</p>
                </div>
              </div>
              
              <p className="text-gray-600 italic leading-relaxed font-nunito text-sm">
                "{testimonial.text}"
              </p>
              
              <div className="mt-4 pt-3 border-t border-gray-100">
                <div className="flex items-center">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-2">
                    <i className="ri-check-line text-red-600 text-xs"></i>
                  </div>
                  <span className="text-xs text-gray-600 font-nunito">Avis vérifié Google</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center bg-white rounded-full px-8 py-4 shadow-lg">
            <div className="flex mr-4">
              {renderStars(5)}
            </div>
            <div className="text-left">
              <p className="font-bold text-gray-800 font-nunito">4.9/5</p>
              <p className="text-sm text-gray-600 font-nunito">Note Google Maps</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
